import { Spacer, Color } from '../../types';

export type DividerProps = {
	my?: Spacer;
	mt?: Spacer;
	mb?: Spacer;
	pullOut?: Spacer;
	borderColor?: Color;
	spacingOnly?: boolean;
};

export const Divider: React.FC<DividerProps> = ({
	pullOut = 0,
	my = 3,
	mt = my,
	mb = my,
	borderColor = 'light-gray',
	spacingOnly
}) => (
	<hr
		className={`divider mt-${mt} mb-${mb} border-${
			spacingOnly ? '0' : borderColor
		}${pullOut > 0 ? ` mx-n${pullOut}` : ''}`}
	/>
);
